import React from 'react';
import {
  Modal,
} from 'react-bootstrap';

export default function AboutModal({
  show,
  onHide,
  children,
}: {
  show: boolean,
  onHide: () => void,
  children: React.ReactNode,
}) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      centered
      className="confirmation-dialog-modal"
    >
      <Modal.Header
        closeButton
        className="confirmation-dialog-modal-header"
      >
        <Modal.Title className="ms-4">
          INSTRUÇÕES
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        { children }
      </Modal.Body>
    </Modal>
  );
}
